import React from 'react'
import App from './App'
import { ContextProvider } from '@monorepo/service'
import '../../assets/reset.css'
import '../../i18n'
import Wrapper from './App/Wrapper'

const Page = () => (
  <ContextProvider>
    <Wrapper>
      <App />
    </Wrapper>
  </ContextProvider>
)

export default Page
